helpers = (function () {
  function getSymbolPos(reel, row, ignoreOffset = false) {
    const symbolReel = resourceManager.get('mainReelsContainer:slotContainer:reelContainer:reel' + reel);
    const symPos = {
      x: symbolReel.x,
      y: symbolReel.y + row * gameData.symbolHeight,
    };

    if (ignoreOffset) {
      return symPos;
    }

    const containerPos = resourceManager.get('mainReelsContainer').position;
    const containerScaleX = resourceManager.get('mainReelsContainer').scale.x;
    const containerScaleY = resourceManager.get('mainReelsContainer').scale.y;

    let pos = {
      x: symPos.x * containerScaleX + containerPos.x,
      y: symPos.y * containerScaleY + containerPos.y,
    };
    return pos;
  }

  function getCentreReelsPos() {
    // Assumes 6x4 reels for this game
    let tl = this.getSymbolPos(2, 1);
    let br = this.getSymbolPos(3, 2);
    let xDiff = br.x - tl.x;
    let yDiff = br.y - tl.y;

    let pos = {
      x: tl.x + xDiff / 2,
      y: tl.y + yDiff / 2,
    };
    return pos;
  }

  /**
   * Get the local pos relative to target container
   */
  getLocalFromGlobalPosition = (sourceObject, targetContainer) => {
    const globalPos = sourceObject.getGlobalPosition();
    return targetContainer.toLocal(globalPos);
  };

  return {
    getSymbolPos: getSymbolPos,
    getCentreReelsPos: getCentreReelsPos,
    getLocalFromGlobalPosition: getLocalFromGlobalPosition,
  };
})();
